import styled from 'styled-components';

export const Container = styled.div`
    border: none !important;
    display: flex;
    margin-bottom: 15px;
    padding-top 0px !important;

    .toolbar-item-section {
        display: flex;
    }

    .section-separator{
        border-left-style: solid;
        border-left-width: 1px;
        border-left-color: #ddd;
        margin: 0px 20px 0px 20px
    }

    .toolbar-toll-item-wrapper {
        margin: 0px 15px 0px 15px;

        .tool-item{
            color: ${(props) => props.theme.richTextToolbar.iconColor};
        }
    }
`;
